import { useEffect } from 'react';
import { useStore } from '../../store';

/**
 * Publish the chart's selected episode to the chat store while this
 * component is mounted, so `ChatInbox` can pin that episode's care-team
 * thread. The panel mounts once in `Layout.tsx` and has no page context of
 * its own. A caller can keep the last episode during a page remount while its
 * replacement chart loads, then clear it once that load settles.
 */
interface ChatContextOptions {
  clearWhenMissing?: boolean;
  clearOnUnmount?: boolean;
}

export function useSetChatContextEpisode(
  episodeId: string | null | undefined,
  { clearWhenMissing = true, clearOnUnmount = true }: ChatContextOptions = {}
): void {
  const setChatContextEpisodeId = useStore(
    state => state.setChatContextEpisodeId
  );

  useEffect(() => {
    if (episodeId !== undefined) {
      setChatContextEpisodeId(episodeId);
    } else if (clearWhenMissing) {
      setChatContextEpisodeId(null);
    }

    if (!clearOnUnmount) return;
    return () => setChatContextEpisodeId(null);
  }, [clearOnUnmount, clearWhenMissing, episodeId, setChatContextEpisodeId]);
}
